import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Redirect } from 'react-router-dom';
import { components as commonComponents } from '@555platform/portal-components/lib/client';
import ListRoles from './ListRoles';
import Lock from '@material-ui/icons/Lock';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { debounce } from '../../../utils';
import { GET_ALL_ROLES_PAGINATED } from './RolesContainer';

const RECORDS_PER_PAGE = 5;

const tableTitle = 'Platform Roles';

const styles = theme => ({
  gradientButton: {
    marginTop: '1rem',
    fontSize: '14px',
    marginRight: '10px',
  },
});

class PlatformRoles extends Component {
  state = {
    open: true,
    searchTxt: '',
		filter: '',
		currentPage: 1,
		skip: 0,
  };
	
	onChangeInput = (e) => {
		this.setState({ searchTxt: e.target.value }, () => {
			debounce(() => {
				this.setState(prevState => ({
					filter: prevState.searchTxt,
				}));
			}, 500)();
		});
  };
  
  onClickPage = (page) => {
		const newSkip = RECORDS_PER_PAGE * (page - 1);
		this.setState({
			currentPage: page,
			skip: newSkip,
		});
	};

  handleClose = () => {
    this.setState({ open: false });
  };

  renderError = () => (
    <commonComponents.ModalErrorDialog
      isOpen={this.state.open}
      onClose={this.handleClose}
      title="Platform Roles"
      message="Oops, we could not access Role data!  Please try again later..."
    />
  );

  renderCreateButton = () => {		
		return (
			<div></div>
		);
  };
  
  renderRoles(roles) {
    const { filter, skip } = this.state;
    return (
      <React.Fragment>
        <br />
        <ListRoles
          {...this.props}
          roles={roles}
          title={tableTitle}
          filter={filter}
          skip={skip}
          limit={RECORDS_PER_PAGE}
          isLoading={false}
        />
      </React.Fragment>
    );

  }

  render() {

    const { open, searchTxt, filter, currentPage, skip } = this.state;

    const { classes } = this.props;

    if (!open) {
      return <Redirect to="/dashboard" />;
    }

    return (
      <Query
        query={GET_ALL_ROLES_PAGINATED}
        notifyOnNetworkStatusChange
        context={{ useLocalError: true }}
        fetchPolicy="network-only"
        variables={{
          filter: filter,
          skip: skip,
          limit: RECORDS_PER_PAGE,
        }}
      >
        {({ data, loading, error }) => {
          if (error) {
            return this.renderError();
          }

          const roles = (data.allRolesPaginated) ? (data.allRolesPaginated.roles) ? data.allRolesPaginated.roles : [] : [];
          const rolesCount = (data.allRolesPaginated) ? (data.allRolesPaginated.count) ? data.allRolesPaginated.count : 0 : 0;

          return (
            <commonComponents.Panel
              id="platformRolesPanel"
              title={tableTitle}
              avatar={(
                <Avatar>
                  <Lock />
                </Avatar>
              )}
            >
              <commonComponents.PaginatedSearch
                searchTxt={searchTxt}
                onChangeInput={this.onChangeInput}
                renderEndpoints={this.renderRoles.bind(this)}
                formPlaceholder="Search Roles"
                currentPage={currentPage}
                thresholdPageBtns={5}
                onClickPage={this.onClickPage}
                footerButton={this.renderCreateButton}
                recordsPerPage={RECORDS_PER_PAGE}
                totalRecords={rolesCount}
                data={roles}
                isLoading={loading}
                {...this.props}
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.gradientButton}
                onClick={() => this.props.history.push(`${this.props.match.url}/create`)
                }
              >
                New Role
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.gradientButton}
                onClick={() => this.props.history.push(`${this.props.match.url}/copy`)
                }
              >
                Copy Role
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.gradientButton}
                onClick={() => this.props.history.push(`${this.props.match.url}/update`)
                }
              >
                Update Role
              </Button>
            </commonComponents.Panel>
          );
        }}
      </Query>
    );
  }
}

export default withStyles(styles)(PlatformRoles);
